import { inject, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const localStorageToken = new InjectionToken<Storage>('LocalStorageService', {
  factory() {
    return isPlatformBrowser(inject(PLATFORM_ID)) ? window.localStorage : null;
  },
});

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storage = inject(localStorageToken);

  get(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  set(key: string, value: any) {
    this.storage?.setItem(key, JSON.stringify(value));
  }
}
